export default ({ children }) => children;